// Editorially checked against the exact manufacturer's release. Source URLs are in the internal review document.
// These are advertised scent notes and accords, not an ingredient declaration.
export const verifiedFragranceNotes: Record<string, { groups: { label: string; notes: string[] }[] }> = {
  'initio-parfums-prives-side-effect-eau-de-parfum': {
    groups: [{ label: 'Main notes', notes: ['Cinnamon', 'Rum', 'Tobacco', 'Saffron', 'Sandalwood', 'Hedione'] }],
  },
  'nishane-hacivat-extrait-de-parfum': {
    groups: [
      { label: 'Top', notes: ['Bergamot', 'Pineapple', 'Grapefruit'] },
      { label: 'Heart', notes: ['Jasmine', 'Patchouli', 'Cedarwood'] },
      { label: 'Base', notes: ['Clearwood', 'Oakmoss', 'Dry timberwood'] },
    ],
  },
  'xerjoff-erba-pura-eau-de-parfum': {
    groups: [
      { label: 'Top', notes: ['Lemon', 'Calabrian bergamot', 'Sicilian orange'] },
      { label: 'Heart', notes: ['Mediterranean fruit'] },
      { label: 'Base', notes: ['Amber', 'Madagascar vanilla beans', 'White musk'] },
    ],
  },
  'maison-francis-kurkdjian-grand-soir-eau-de-parfum': {
    groups: [
      { label: 'Opening accord', notes: ['Cistus labdanum', 'Lavandin', 'Cinnamon leaf'] },
      { label: 'Base accord', notes: ['Amber-vanilla accord', 'Benzoin facets'] },
    ],
  },
  'diptyque-orpheon-eau-de-parfum': {
    groups: [{ label: 'Main notes', notes: ['Juniper berry', 'Cedar', 'Tonka bean', 'Jasmine'] }],
  },
};
